export default function numberComma(inputNumber) {
	try {
		return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	} catch (e) {
		return '';
	}
}
